import { fetcher } from "helpers/fetcher";

import { TGetScorecardDetailsReq, TGetScorecardDetailsRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getScorecardDetails = async (payload: TGetScorecardDetailsReq) => {
  return await fetcher<TGetScorecardDetailsRes, any>(
    ENDPOINT.MANAGEMENT.GET_SCORECARD_DETAILS,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_SCORECARD_DETAILS.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: payload.urlData,
    }
  );
};

export const queryGetScorecardDetails = async (
  payload: TGetScorecardDetailsReq
) => {
  return (await getScorecardDetails(payload)).data;
};

queryGetScorecardDetails._key = (payload: TGetScorecardDetailsReq) => [
  ENDPOINT.MANAGEMENT.GET_SCORECARD_DETAILS.url,
  payload,
];
